module.exports = __webpack_public_path__ + "img/overview.487f419f.png";